// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { EnumTenancyType } from '../../../../../com/MetaPattern/APP/MDA/User/EnumTenancyType';
import { User } from './User';
import { Organization } from './Organization';
import { Person } from './Person';
import { TenancyLevel } from './TenancyLevel';
/**
 * 租户 实体类
 * 租户，平台的结算主体
 */
export class Tenancy extends BaseEntity {
  /** 租户类型 : 租户类型 */
  private _tenancyType: EnumTenancyType;

  /** 设置：租户类型 */
  public get tenancyType() {
    return this._tenancyType;
  }

  /** 获取：租户类型 */
  public set tenancyType(value: EnumTenancyType) {
    this._tenancyType = value;
  }

  /** 用户 */
  private _users: Array<User>;

  /** 获取：用户 */
  public get users() {
    return this._users;
  }

  /** 设置：用户 */
  public set users(value: Array<User>) {
    this._users = value;
  }

  /** 机构 的ID */
  private _organization_ID: string;

  /** 获取：机构 的ID */
  public get organization_ID() {
    return this._organization_ID;
  }

  /** 设置：机构 的ID */
  public set organization_ID(value: string) {
    this._organization_ID = value;
  }

  /** 机构  */
  private _organization: Organization;

  /** 获取：机构  */
  public get organization() {
    return this._organization;
  }

  /** 设置：机构  */
  public set organization(value: Organization) {
    this._organization = value;
    if (value !== null) {
      this.organization_ID = value.id;
    } else {
      this.organization_ID = '';
    }
  }

  /** 个人 的ID */
  private _person_ID: string;

  /** 获取：个人 的ID */
  public get person_ID() {
    return this._person_ID;
  }

  /** 设置：个人 的ID */
  public set person_ID(value: string) {
    this._person_ID = value;
  }

  /** 个人  */
  private _person: Person;

  /** 获取：个人  */
  public get person() {
    return this._person;
  }

  /** 设置：个人  */
  public set person(value: Person) {
    this._person = value;
    if (value !== null) {
      this.person_ID = value.id;
    } else {
      this.person_ID = '';
    }
  }

  /** 租户等级 的ID */
  private _tenancyLevel_ID: string;

  /** 获取：租户等级 的ID */
  public get tenancyLevel_ID() {
    return this._tenancyLevel_ID;
  }

  /** 设置：租户等级 的ID */
  public set tenancyLevel_ID(value: string) {
    this._tenancyLevel_ID = value;
  }

  /** 租户等级  */
  private _tenancyLevel: TenancyLevel;

  /** 获取：租户等级  */
  public get tenancyLevel() {
    return this._tenancyLevel;
  }

  /** 设置：租户等级  */
  public set tenancyLevel(value: TenancyLevel) {
    this._tenancyLevel = value;
    if (value !== null) {
      this.tenancyLevel_ID = value.id;
    } else {
      this.tenancyLevel_ID = '';
    }
  }

  constructor() {
    super();
    this._tenancyType = EnumTenancyType.Person;
    this._users = new Array<User>();
    this._organization_ID = '';
    this._organization = null;
    this._person_ID = '';
    this._person = null;
    this._tenancyLevel_ID = '';
    this._tenancyLevel = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Tenancy, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.tenancyType = element.tenancyType;
      this.organization_ID = element.organization_ID;
      if (hasReference && element.organization !== null) {
        this.organization = element.organization;
      }
      this.person_ID = element.person_ID;
      if (hasReference && element.person !== null) {
        this.person = element.person;
      }
      this.tenancyLevel_ID = element.tenancyLevel_ID;
      if (hasReference && element.tenancyLevel !== null) {
        this.tenancyLevel = element.tenancyLevel;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.tenancyType = json.TenancyType as EnumTenancyType;
    if (json.Users && json.Users.length > 0) {
      json.Users.forEach((element: any) => {
        const user = User.Create(element);
        // user.tenancy = this;
        this.users.push(user);
      });
    }
    this.organization_ID = json.Organization_ID;
    // if (json.Organization !== null) {
    //   this.organization = Organization.Create(json.Organization);
    // }
    this.person_ID = json.Person_ID;
    // if (json.Person !== null) {
    //   this.person = Person.Create(json.Person);
    // }
    this.tenancyLevel_ID = json.TenancyLevel_ID;
    // if (json.TenancyLevel !== null) {
    //   this.tenancyLevel = TenancyLevel.Create(json.TenancyLevel);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.TenancyType = this.tenancyType;
    if (this.users && this.users.length > 0) {
      json.Users = [];
      this.users.forEach((element) => {
        json.Users.push(element.toJson());
      });
    }
    json.Organization_ID = this.organization_ID;
    json.Person_ID = this.person_ID;
    json.TenancyLevel_ID = this.tenancyLevel_ID;
  }

  static Create(json: any): Tenancy {
    const tenancy = new Tenancy();
    tenancy.Deserialize(json);
    tenancy.json = json;
    return tenancy;
  }
}
